import {Component, Input} from '@angular/core';
import {PaymentReceiptParty} from '@gatewee/types/payment';
import {Withdrawal} from '@gatewee/types/withdrawal';
import {
  formatRecipientAccount,
  formatRecipientAgency,
  resolveCompeDisplayName,
} from '@gatewee/utils';

@Component({
  selector: 'gatewee-withdrawal-receiver-tableitem-v2',
  templateUrl: './gatewee-withdrawal-receiver-tableitem-v2.component.html',
  styleUrls: ['./gatewee-withdrawal-receiver-tableitem-v2.component.css'],
  standalone: false,
})
export class GateweeWithdrawalReceiverTableitemV2Component {
  @Input() withdrawal!: Withdrawal;

  @Input() photo = true;

  @Input() nameLength = 25;

  @Input() smallFont = false;

  @Input() size: 's' | 'm' | 'l' = 'm';

  private get receiptReceiver(): PaymentReceiptParty | undefined {
    return this.withdrawal?.paymentMetadata?.receipt?.receiver;
  }

  get receiverName(): string {
    const receipt = this.receiptReceiver;
    const info = this.withdrawal?.receiverPaymentInfo;
    return String(
      receipt?.holderName ?? info?.holderName ?? info?.name ?? '',
    ).trim();
  }

  get displayName(): string {
    const name = this.receiverName;
    if (!name) return '';
    if (name.length <= this.nameLength) return name;
    return name.substring(0, this.nameLength) + '...';
  }

  get pixKey(): string {
    const receipt = this.receiptReceiver;
    const info = this.withdrawal?.receiverPaymentInfo;
    return String(receipt?.pixKey ?? info?.pixKey ?? '').trim();
  }

  get pixKeyType(): string {
    return String(
      this.withdrawal?.receiverPaymentInfo?.pixKeyType ?? '',
    ).trim();
  }

  get hasPixKey(): boolean {
    return !!this.pixKey;
  }

  get bankName(): string {
    const recv = this.receiptReceiver;
    if (!recv) {
      return '';
    }

    return resolveCompeDisplayName(recv.compeCode, recv.ispbCode).trim();
  }

  get agencyLine(): string {
    if (this.hasPixKey) {
      return '';
    }

    const recv = this.receiptReceiver;
    if (!recv) {
      return '';
    }

    return formatRecipientAgency(recv.agency);
  }

  get accountLine(): string {
    if (this.hasPixKey) {
      return '';
    }

    const recv = this.receiptReceiver;
    if (!recv) {
      return '';
    }

    return formatRecipientAccount(recv.account);
  }
}
